import Vue from "vue";
import { mapState } from "vuex";

import buttonScComponent from "@/components/child/form/buttonSc.vue";
import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import infoBagdeComponent from "@/components/child/infoBagde/infoBagde.vue";
import { Component } from "@/decorators";
import StatusOrdemPagamento from "@/models/enum/financeiro/statusOrdemPagamento";
import ContaReceberModel from "@/models/financeiro/contaReceberModel";
import OrdemPagamentoModel from "@/models/financeiro/gatewayPagamento/ordemPagamentoModel";
import UsuarioModel from "@/models/usuarioModel";
import configuracaoGatewayPagamentoService from "@/services/configuracaoGatewayPagamentoService";
import OrdemPagamentoService from "@/services/ordemPagamentoService";
import { AppState } from "@/store/store";
import { convertToDateInputString } from "@/utils/common/date";

import "../../crud/crud.scss";

const ordemPagamentoService = new OrdemPagamentoService();

@Component({
    components: {
        buttonScComponent,
        fieldsetComponent,
        comboComponent,
        infoBagdeComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class GerarBoletoComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;

    contaReceber: ContaReceberModel;
    linkBoletoPagamento = "";
    boletoPago = false;
    showBoleto = false;
    gateway = null;
    gatewaysOptions = [];

    public async loadLinkBoleto(model: ContaReceberModel) {
        this.contaReceber = model;

        this.showBoleto = this.contaReceber.id > 0 && this.gatewaysOptions.length > 0;

        const ordemPagamento = await ordemPagamentoService
            .getOrdemPagamentoAtivoByContaReceberId(this.contaReceber.id)
            .withLoading()
            .resolveWithJSON<OrdemPagamentoModel>();

        if (ordemPagamento) {
            this.linkBoletoPagamento = ordemPagamento.boleto.linkBoleto;
            this.boletoPago = ordemPagamento.status === StatusOrdemPagamento.Pago;
            this.gateway = ordemPagamento.gatewayPagamento;
        } else {
            this.linkBoletoPagamento = "";
            this.boletoPago = false;
        }
    }

    public async criarBoleto() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                if (this.linkBoletoPagamento) {
                    const response = await this.$showAlert({
                        title: this.$t("__.ts.gerarNovoBoleto") as string,
                        text: this.$t("__.ts.gerarNovoBoletoMensagem") as string,
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonText: this.$t("__.ts.sim") as string,
                        cancelButtonText: this.$t("__.ts.nao") as string,
                    });

                    if (!response.isConfirmed) {
                        return;
                    }
                }

                const ordemPagamento = await ordemPagamentoService
                    .criarOrdemPagamentoByContaReceberId(
                        this.contaReceber.id,
                        this.contaReceber.valorTotal,
                        convertToDateInputString(this.contaReceber.dataVencimento),
                        this.gateway,
                    )
                    .withLoading()
                    .resolveWithJSON<OrdemPagamentoModel>();

                if (ordemPagamento) {
                    this.linkBoletoPagamento = ordemPagamento.boleto.linkBoleto;
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private async copiarLinkBoleto() {
        await navigator.clipboard.writeText(this.linkBoletoPagamento);

        this.$notifySuccess(this.$t("__.ts.linkCopiado") as string);
    }

    private async mounted() {
        this.gatewaysOptions = await configuracaoGatewayPagamentoService.comboCached(this.usuarioLogado.franquiaId);

        if (this.gatewaysOptions.length === 1) {
            this.gateway = this.gatewaysOptions[0].value;
        }
    }
}
